import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

var props = {};
props.api     = document.getElementById('player').getAttribute('api');
props.shows   = document.getElementById('player').getAttribute('shows');
props.feed    = document.getElementById('player').getAttribute('feed');
props.country = document.getElementById('player').getAttribute('country');

new Vue({
  render: h => h(App, {
    props
  }),
}).$mount('#player')
